import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token } from '../../../../Login/Auth';

import { ReqLeagueList, get_league_type_string } from '../../../../../item/MyStat/ItemLeague';
import { api_getClientList, api_setClientActCodeCap, api_setClientActivation, api_setClientActivationCode } from '../../../../../api/MyStat/apiClient';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_color, get_activation_string, ACTIVATION_DISABLE } from '../../../../../item/MyStat/ItemMyStatBase';
import { ReqClient, RespClient } from '../../../../../item/MyStat/ItemClient';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


import { SingleDatePickerInput, SingleInput } from '../../../Res/BaseInput';
import { ModalDialog } from 'react-bootstrap';

export function ClientList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [clientList, setClientList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    const [list_obj, set_list_obj] = useState({})

    const MySwal = withReactContent(Swal)

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqClient = new ReqClient({ start, limit })
            if (url === "") {
                toSearch({ items: mReqClient, page: url.page })
            } else {
                mReqClient.fromJson(url)
                // console.log(mReqClient)
                toSearch({ items: mReqClient, page: url.page })
            }
        }
    }, [id])

    useEffect(() => {
        var contents = []
        clientList.forEach(item => {
            var content = []
            content.push(setTD({ content: item.team_name }))
            content.push(setTD({
                content: get_activation_string(item.activation), color: get_activation_color(item.activation),
                action: setActivation, actionVal: item.activation, actionKey: item.team_id
            }))
            content.push(setTDLink({ link: 'Client_Edit',content: moment(item.startDate).format('YYYY-MM-DD') + "～" + moment(item.endDate).format('YYYY-MM-DD'), key: 'ClientEdit', val: item }))
            content.push(setTD({ content: "0/" + item.actCodeCap, action: setActCodeCap, actionVal: item.actCodeCap, actionKey: item.team_id }))
            content.push(setTD({ content: item.admin }))
            content.push(setTD({ content: item.activationCode || "N/A", action: setActivationCode, actionVal: item.activation, actionKey: item.team_id }))
            content.push(setTD({ content: item.activationCodeCreatAt !== null ? moment(item.activationCodeCreatAt).format('YYYY-MM-DD hh:mm') : "" }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('球隊名稱', 3),
                new TableListTitle('啟停用', 1),
                new TableListTitle('啟迄日', 3),
                new TableListTitle('使用人數', 2),
                new TableListTitle('管理員帳號', 1),
                new TableListTitle('啟動碼', 1),
                new TableListTitle('啟動時間', 1),
            ],
            contents
        }

        set_list_obj(lb)
    }, [clientList])

    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        //console.log(items)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqClient = new ReqClient({ start, limit })
        if (items !== undefined)
            mReqClient.fromJson(items)
        // setReqLeagueList(mReqClient)
        setVal2Token("url", mReqClient, id)
        getClientList(mReqClient)
    }

    function getClientList(mReqClient) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        //console.log("getCustomerContractList")
        //console.log(mReqCustomerContractList)
        // console.log(mReqClient)
        api_getClientList({
            mReqClient,
            success: (obj) => {
                console.log(obj)
                setClientList(obj.list)
                setCount(obj.count)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/Client_Add");
    }



    function setActivation(key, val) {
        console.log("key" + key)
        console.log("val" + val)
        Swal.fire({
            title: val === ACTIVATION_ENABLE ? "啟用中" : "停用中",
            text: val === ACTIVATION_ENABLE ? "是否要停用" : "是否要啟用",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是',
            cancelButtonText: '否'
        }).then((result) => {
            if (result.value) {
                setIsLoading(true)
                val = val === ACTIVATION_ENABLE ? ACTIVATION_DISABLE : ACTIVATION_ENABLE
                var mRespClient = new RespClient({ team_id: key, activation: val })
                console.log(mRespClient)
                api_setClientActivation({
                    mRespClient,
                    success: (obj) => {
                        // console.log(obj)
                        setIsLoading(false)
                        var mClientList = []
                        clientList.forEach(client => {
                            if (client.team_id === key) {
                                client.activation = val
                            }
                            mClientList.push(client)
                        })
                        setClientList(mClientList)
                        ///傳送 api
                        Swal.fire(
                            val === ACTIVATION_ENABLE ? "啟用中" : "停用中",
                            '',
                            'success'
                        )
                    },
                    failure: (err) => {
                        console.log(err)
                        setIsLoading(false)
                        //window.location.replace("/AdminManagerList");
                    }
                })
            }
        })
    }

    function setActCodeCap(key, val) {
        console.log("key" + key)
        console.log("val" + val)
        Swal.fire({
            title: "人數上限",
            text: "是否要變更人數上限",
            input: 'number',
            inputValue: val,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是',
            cancelButtonText: '否'
        }).then((result) => {
            if (result.value) {
                setIsLoading(true)
                var mRespClient = new RespClient({ team_id: key, actCodeCap: result.value })
                console.log(mRespClient)
                api_setClientActCodeCap({
                    mRespClient,
                    success: (obj) => {
                        console.log(obj)
                        setIsLoading(false)
                        var mClientList = []
                        clientList.forEach(client => {
                            if (client.team_id === key) {
                                client.actCodeCap = result.value
                            }
                            mClientList.push(client)
                        })
                        setClientList(mClientList)
                    },
                    failure: (err) => {
                        console.log(err)
                        setIsLoading(false)
                        //window.location.replace("/AdminManagerList");
                    }
                })
            }
        })
    }

    function setActivationCode(key, val) {
        console.log("key" + key)
        console.log("val" + val)
        Swal.fire({
            title: "啟動碼",
            text: "是否要產生新的啟動碼？產生後該帳號就不能以原密碼登入了",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是',
            cancelButtonText: '否'
        }).then((result) => {
            if (result.value) {
                setIsLoading(true)
                var mRespClient = new RespClient({ team_id: key })
                console.log(mRespClient)
                api_setClientActivationCode({
                    mRespClient,
                    success: (obj) => {
                        console.log(obj)
                        setIsLoading(false)
                        var mClientList = []
                        clientList.forEach(client => {
                            if (client.team_id === key) {
                                client.activationCode = obj.activationCode
                                client.activationCodeCreatAt = obj.activationCodeCreatAt
                            }
                            mClientList.push(client)
                        })
                        setClientList(mClientList)
                    },
                    failure: (err) => {
                        console.log(err)
                        setIsLoading(false)
                        //window.location.replace("/AdminManagerList");
                    }
                })
            }
        })
    }

    function setDate(key, val) {
        console.log("key" + key)
        console.log("val" + val)
        window.location.assign("/Client_Edit");
    }

    var baseTitle = "授權球隊列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <AddButton name={"新增"} action={toAdd} isRight={true} />
                </div>
            </div>
            <Space />
            <ListBox row={7} lb={list_obj} srl={setClientList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

